import type { Location } from '@/api/types';

/**
 * The restaurant's address, as the lines a receipt prints.
 *
 * WHY LINES RATHER THAN A STRING. The emailed receipt joins these with commas because an email is a
 * paragraph; a receipt on a phone reads the way a printed one does, street on one line and the rest below.
 * The server sends the parts precisely so this choice lives here.
 *
 * Every part is optional — a location is not required to have finished setting itself up — so a missing
 * piece closes up rather than leaving a gap, a stray comma, or a line with nothing on it.
 */
export function addressLines(location: Location): string[] {
    const street = [location.address1, location.address2].filter(Boolean).join(', ');

    /*
     * "Nashville, TN 37201", and still right when pieces are missing: no city means no comma, no state means
     * no stranded space before the postal code. Built by joining what is there rather than by formatting a
     * template and tidying up afterwards.
     */
    const locality = [[location.city, location.state].filter(Boolean).join(', '), location.postalCode]
        .filter(Boolean)
        .join(' ');

    return [street, locality].filter((line) => line.length > 0);
}

